import ClassCategoriesManageModal from '@/features/profile/classes/ClassCategoriesManageModal';
import { useProfileClassOrganizationStore } from '@/features/profile/classes/profileClassOrganizationStore';

export default function ClassCategoriesManageModalHost() {
  const isManageCategoriesOpen = useProfileClassOrganizationStore(
    (state) => state.isManageCategoriesOpen,
  );
  const closeManageCategories = useProfileClassOrganizationStore(
    (state) => state.closeManageCategories,
  );

  if (!isManageCategoriesOpen) {
    return null;
  }

  return <ClassCategoriesManageModal onClose={closeManageCategories} />;
}
